import { createFileRoute } from '@tanstack/react-router';
import { NewPhonePage } from '@/features/portal/NewPhonePage';

// After a recovery code this is the only page there is (PHONE_RELINK_REQUIRED);
// from the account page it is the way to move to another phone.
export const Route = createFileRoute('/portal/_portal/new-phone')({
  component: NewPhoneRoute,
});

function NewPhoneRoute() {
  const { me } = Route.useRouteContext();
  return <NewPhonePage me={me} />;
}
